import { render } from "./HeaderBoromir.vue?vue&type=template&id=45a20945&scoped=true"
import script from "./HeaderBoromir.vue?vue&type=script&lang=js"
export * from "./HeaderBoromir.vue?vue&type=script&lang=js"

import "./HeaderBoromir.vue?vue&type=style&index=0&id=45a20945&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a20945"]])

export default __exports__